import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface IState extends IDefaultState<any, any, any> {}

const initialState:IState = {
  ...defaultInitialState,
};

const reducers = {
  ...defaultReducers,
  setActiveMeasures: (state:IState, action:PayloadAction<any>) => {
    state.dropDownItems = action.payload;
  },
};

export const articleUnitsOfMeasureSlice = createSlice({
  name: "articleUnitsOfMeasure",
  initialState,
  reducers,
});

